import { cn } from "@/lib/utils";
import Navbar from "@/src/app/(auth)/_components/Navbar";

interface AppContentContainerProps {
  bottomBar?: React.ReactNode;
  className?: string;
  children: React.ReactNode;
}

function AppContentContainer({
  bottomBar,
  className,
  children,
}: AppContentContainerProps) {
  return (
    <div className="h-full overflow-y-scroll">
      <Navbar />
      <div
        className={cn(
          bottomBar ? "min-h-[calc(100%-128px)]" : "min-h-[calc(100%-64px)]",
          className,
        )}
      >
        {children}
      </div>
      {bottomBar}
    </div>
  );
}
export default AppContentContainer;
